/**
 * A provider logo as it appears on the gradient sign-in button: every non-transparent pixel turned
 * white, inside a translucent ring. Works for the API presets and for uploaded logos alike, as long as
 * the artwork has a transparent background.
 */
export default function SsoProviderLogo({ src }: { src: string }) {
  return (
    <span className="flex h-8 w-8 items-center justify-center rounded-full bg-white/20">
      <img
        src={src}
        alt=""
        className="h-[18px] w-[18px] object-contain brightness-0 invert"
        data-testid="sso-provider-icon"
      />
    </span>
  );
}
